export const categories = [
  {
    slug: "latest-links",
    name: "最新入口",
    icon: "ri-link-m",
    description: "91蜜桃最新可用入口地址汇总，实时更新确保您始终掌握最新访问方式。",
    color: "primary",
  },
  {
    slug: "usage-guide",
    name: "使用教程",
    icon: "ri-book-open-line",
    description: "详细的平台功能使用教程，从入门到精通，助您全面掌握平台各项功能。",
    color: "accent",
  },
  {
    slug: "faq",
    name: "常见问题",
    icon: "ri-question-answer-line",
    description: "用户常见问题及详细解决方案汇总，涵盖访问、注册、使用等各方面问题。",
    color: "secondary",
  },
  {
    slug: "security-guide",
    name: "安全指南",
    icon: "ri-safe-2-line",
    description: "91蜜桃安全访问防护指南与个人隐私保护建议，为您的在线安全保驾护航。",
    color: "primary",
  },
  {
    slug: "platform-news",
    name: "平台动态",
    icon: "ri-newspaper-line",
    description: "91蜜桃平台最新公告、版本更新日志与重要通知，随时了解平台最新变化。",
    color: "accent",
  },
];

export const categoryPageData: Record<string, {
  title: string;
  description: string;
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string;
}> = {
  "latest-links": {
    title: "最新入口地址",
    description: "收录91蜜桃所有最新可用的访问入口地址，包括主入口、备用入口及镜像地址，实时更新确保您随时畅享平台。",
    seoTitle: "91蜜桃最新入口地址 - 91蜜桃官方入口导航",
    seoDescription: "收录91蜜桃所有最新可用的访问入口地址，包括主入口、备用入口及镜像地址，实时更新确保您随时畅享平台内容。91蜜桃入口、最新链接一站获取。",
    seoKeywords: "91蜜桃最新入口,91蜜桃入口地址,91蜜桃链接,91蜜桃官网入口,蜜桃视频入口",
  },
  "usage-guide": {
    title: "使用教程",
    description: "91蜜桃平台详细使用教程，从注册登录到功能操作，手把手教您全面掌握平台使用方法。",
    seoTitle: "91蜜桃使用教程 - 91蜜桃平台操作指南",
    seoDescription: "91蜜桃平台详细使用教程，从注册登录到功能操作，手把手教您全面掌握平台使用方法。蜜桃视频使用指南，让您轻松上手。",
    seoKeywords: "91蜜桃使用教程,蜜桃视频教程,91蜜桃怎么用,91蜜桃操作指南,蜜桃在线使用",
  },
  "faq": {
    title: "常见问题",
    description: "91蜜桃用户常见问题解答汇总，包含访问问题、账号问题、功能使用等各类FAQ，帮您快速解决疑惑。",
    seoTitle: "91蜜桃常见问题解答 - 91蜜桃FAQ帮助中心",
    seoDescription: "91蜜桃用户常见问题解答汇总，包含访问问题、账号问题、功能使用等各类FAQ，帮助用户快速解决疑惑。",
    seoKeywords: "91蜜桃常见问题,91蜜桃FAQ,蜜桃视频问题,91蜜桃帮助,蜜桃在线答疑",
  },
  "security-guide": {
    title: "安全指南",
    description: "91蜜桃安全访问防护指南，提供个人隐私保护建议、安全上网技巧及风险防范措施。",
    seoTitle: "91蜜桃安全指南 - 91蜜桃安全访问防护",
    seoDescription: "91蜜桃安全访问防护指南，提供个人隐私保护建议、安全上网技巧及风险防范措施。保障您的蜜桃在线使用安全。",
    seoKeywords: "91蜜桃安全,91蜜桃防护,蜜桃视频安全,安全访问指南,在线安全",
  },
  "platform-news": {
    title: "平台动态",
    description: "91蜜桃平台最新公告、版本更新日志与重要通知，随时了解平台运营动态与最新变化。",
    seoTitle: "91蜜桃平台动态 - 91蜜桃最新公告与更新",
    seoDescription: "91蜜桃平台最新公告、版本更新日志与重要通知，随时了解平台运营动态与最新变化。蜜桃视频最新消息一站掌握。",
    seoKeywords: "91蜜桃动态,91蜜桃公告,91蜜桃更新,蜜桃视频新闻,平台公告",
  },
};